import React from 'react';

const ChartCardContext = React.createContext({
  isExpanded: false,
  expandChart: () => {},
  collapseChart: () => {},
});

export default ChartCardContext;